import Checkbox from '@mui/material/Checkbox';
import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../../generic/Flex';

type Props = {
  shouldHideCheckbox?: boolean;
};

/**
 * Represents a single loading row for the issues table.
 * Note that this isn't a React component and should not be "called",
 * instead just render it directly.
 */
const IssueItemLoading: VoidFunctionComponent<Props> = ({ shouldHideCheckbox }) => (
  <div className="issue-loading-row">
    {!shouldHideCheckbox && (
      <Flex align="flex-start">
        <Checkbox
          checked={false}
          disabled
        />
      </Flex>
    )}
    <Flex grow="1">
      <ContentLoader
        width="100%"
        height="30px"
      >
        <rect x="0" y="0" rx="3" ry="3" width="90%" height="10" />
        <rect x="0" y="20" rx="3" ry="3" width="70%" height="10" />
      </ContentLoader>
    </Flex>
  </div>
);

export default IssueItemLoading;
